/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import RoomList from './partials/RoomList';
import Sharing from './partials/Sharing';
import Loading from './partials/Loading';
import './GiftCards.css';

import {
  getGiftCards,
} from '../actions';


class GiftCards extends OzComponent {

  static need = [
    ['giftCards', getGiftCards],
  ];

  state = {};

  componentDidMount() {
    try {
      scroll(0, 0);
    } catch (e) {}
  }

  renderGiftCards() {
    let giftCards = this.props.giftCards;
    if (!giftCards) return <Loading />;

    let i = 0;
    let nodes = giftCards.giftCards.map(gc => {
      return (
        <div className="gift-card" key={i++}>
          <div className={cx('img-wrapper', { 'no-image': !gc.img })}>
            <div className="img" style={{ backgroundImage: 'url(' + gc.img + ')' }}>
            </div>
          </div>
          <div className="company">{gc.companyName}</div>
          <div className="location">{gc.locationPretty}</div>
          {gc.msg && <div className="msg">{gc.msg}</div>}
          <div className="spacer"></div>
          <div className="discount">{gc.giftCardDiscount}% off</div>
          <div className="buy"><Button bsStyle="primary" bsSize="large">Buy Gift Card</Button></div>
        </div>
      );
    });

    return (
      <div className="gift-cards">
        {nodes}
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="GiftCards" title="Discount Gift Cards">
        <div className="content-padded">
          <p>
            Some escape rooms are selling discount gift cards during COVID-19. Purchasing these cards lets you play the rooms at a discount when the companies re-open, and helps support escape rooms so they can weather lockdowns during this crisis.
          </p>

          <div className="sharing-blurb">
            <p>Share this list with your friends to help support escape rooms during the ongoing health crisis.</p>
            <Sharing url="https://www.escapespy.com/gift-cards" />
          </div>
          <hr />

          {this.renderGiftCards()}
        </div>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    giftCards: state.get.giftCards,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiftCards);



/** WEBPACK FOOTER **
 ** ./src/components/GiftCards.js
 **/